module.exports = __webpack_public_path__ + "bd6bacd3c2984e392777c2c33c6d8651.MP3";